export class ClusterEvalModel
{
    fromCentre: number=-1;//mark of unchanged, cant be -1 0 is a very common number
    distanceMean: number=-1;
    distanceMedian: number=-1;
    clusterConsistency: number=-1;
    clusterRating: number=-1;
    clusters: number[] = [];
    newEmbedding: number[][]=[];
}